import type { ReactNode } from "react";

import { ErrorOutlineIcon } from "@citrine/atoms/icons";
import { Tooltip } from "@citrine/atoms/tooltip";

export const ERROR_OUTLINE_ICON_WITH_TOOLTIP_TESTID = "error-outline-icon";

export function ErrorOutlineIconWithTooltip({
  className,
  error,
}: {
  className?: string;
  error: ReactNode;
}) {
  return error ? (
    <Tooltip
      data-testid={ERROR_OUTLINE_ICON_WITH_TOOLTIP_TESTID}
      error={error}
      errorPlacement="bottom"
    >
      <ErrorOutlineIcon className={className} fontSize="small" />
    </Tooltip>
  ) : null;
}
